import { render, staticRenderFns } from "./articleCom.vue?vue&type=template&id=72509c8e"
import script from "./articleCom.vue?vue&type=script&lang=js"
export * from "./articleCom.vue?vue&type=script&lang=js"
import style0 from "./articleCom.vue?vue&type=style&index=0&id=72509c8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports